import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { MenuComponent } from '../../layout/menu/menu.component';
import { RodapeComponent } from '../../layout/rodape/rodape.component';

@Component({
  selector: 'app-email-corporativo',
  standalone: true,
  imports: [
    MenuComponent,
    RodapeComponent
  ],
  templateUrl: './email-corporativo.component.html',
  styleUrl: './email-corporativo.component.css'
})
export class EmailCorporativoComponent implements OnInit, AfterViewInit {
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private title: Title, 
    private meta: Meta
  ) {}

  ngOnInit() {
    this.title.setTitle('E-mail Corporativo Profissional - Fluxodigital');
    this.meta.updateTag({ 
      name: 'description', 
      content: 'E-mail corporativo profissional com sua marca. Segurança, sincronização e suporte local em Angola.' 
    });

    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: 'E-mail Corporativo Profissional - Fluxodigital' });
    this.meta.updateTag({ property: 'og:description', content: 'Impulsione sua credibilidade com e-mails personalizados para sua empresa.' });
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId) && this.videoPlayer) {
      const video = this.videoPlayer.nativeElement;
      video.muted = true;
      video.play().catch(error => {
        console.error("Video autoplay failed:", error);
      });
    }
  }
}
